import AuthStore from "@/modules/auth/services/Store"
import ApiBase from "@/modules/auth/services/ApiBase"
import AuthToken from "@/modules/auth/services/Token"
import AuthClient from "@/modules/auth/services/Client"
import { jwtDecode } from "jwt-decode"

export default new class Auth {
    recoverySession() {
        if (!AuthStore.isAuth() && !AuthStore.isTryAuth()) {
            return this.authenticate()
        } else {
            return new Promise((resolve) => {
                resolve()
            });
        }
    }

    authenticate() {
        return new Promise((resolve, reject) => {
            ApiBase.session().then((response) => {
                const item = response.data["item"]

                const userSourceId = response?.data?.extra?.user_source_id
                if (!userSourceId) {
                    new Error("Отсутствует sourceId")
                }

                this.setDataLogin(item, userSourceId)

                resolve({
                    "role_id": item.role_id,
                });
            }).catch((error) => {
                if (error.response.status !== 401) {
                    reject(error)
                    return
                }

                let token = this.getToken()
                let client = this.getClient()

                if (!token || !client) {
                    reject(error)
                    return
                }

                ApiBase.refresh({
                    token,
                    client,
                }).then((response) => {
                    const item = response.data["item"]
                    this.setToken(item["token"]);

                    const userSourceId = response?.data?.extra?.user_source_id
                    if (!userSourceId) {
                        new Error("Отсутствует sourceId")
                    }

                    this.setDataLogin(item, userSourceId)

                    resolve({
                        "role_id": item.role_id,
                    });
                }).catch(() => {
                    reject(error)
                })
            }).finally(() => {
                this.markTryAuth()
            });
        })
    }

    logout() {
        return new Promise((resolve, reject) => {
            let client = this.getClient()

            ApiBase.logout({
                client,
            }).then(() => {
                this.removeToken()
                this.removeDataLogin()

                resolve();
            }).catch((resp) => {
                reject(resp);
            });
        })
    }

    markTryAuth() {
        AuthStore.markTryAuth()
    }

    setToken(token) {
        AuthToken.set(token);
    }

    getToken() {
        return AuthToken.get();
    }

    removeToken() {
        AuthToken.remove()
    }

    setClient(client) {
        AuthClient.set(client);
    }

    getClient() {
        return AuthClient.get()
    }

    setDataLogin(data, userSourceId) {
        let token = this.getToken()

        const tokenDecode = jwtDecode(token)

        let permissions = []
        if (tokenDecode?.permissions) {
            permissions = tokenDecode.permissions
        }
        
        AuthStore.setDataLogin({
            id: data["id"],
            name: data["name"],
            role: data["role"],
            role_id: data["role_id"],
            role_code: data["role_code"],
            phantom: data["fantom"],
            avatar: {
                "host": data["avatar_host"],
                "name": data["avatar_name"],
            },
            permissions: permissions,
            user_source_id: userSourceId,
        })
    }

    removeDataLogin() {
        AuthStore.clearDataLogin()
    }
}